import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

class Authentication extends Component {
  handleRender = (props) => {
    if (!this.props.isAuthenticated || this.props.resetPWD) {
      return <Redirect to={{
        pathname: '/login',
        state: { from: props.location, message: 'You need to sign in' }
      }}/>
    } else {
      return <this.props.component {...props}/>
    }
  }

  render() {
    const { component, isAuthenticated, resetPWD, ...rest } = this.props;
    return <Route {...rest} render={this.handleRender}/>
  }
}

const ConnectedAuthentication = connect((store) => ({
  isAuthenticated: store.auth.isAuthenticated,
  resetPWD: store.auth.resetPWD
}))(Authentication);

const PrivateRoute = ({ component, ...rest }) => (
  <ConnectedAuthentication component={component} {...rest} />
);

export default PrivateRoute;